import { IS_TESTING_PATH } from "../../framework/firebase/DBPathConstants";
import { GameIdFirebaseWrapper } from "../../framework/firebase/GameIdFirebaseWrapper";
import { Layer } from "../../framework/layer/Layer";
export class SetTestingModeLayer extends Layer {
    constructor(firebase, playerAndGameIdProvider, isTestingMode, gameIndex) {
        super([]);
        this.firebase = firebase;
        this.playerAndGameIdProvider = playerAndGameIdProvider;
        this.isTestingMode = isTestingMode;
        this.gameIndex = gameIndex;
    }
    activate() {
        if (this.isTestingMode && this.gameIndex === 0) {
            const gameIdFirebase = new GameIdFirebaseWrapper(this.firebase, this.playerAndGameIdProvider.data.gameId);
            gameIdFirebase.set(IS_TESTING_PATH, true);
        }
    }
    getLayerData() {
        return null;
    }
    update(inEvent) {
        return null;
    }
    close() {
    }
}
//# sourceMappingURL=SetTestingModeLayer.js.map